import { IconContent } from '@icons';

export const housingFilled: IconContent = {
    md: '<path d="M4.349 9.241A1 1 0 0 0 5 11h14v1h-1v7-7H5v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8a1 1 0 0 0 .65-1.76l-1.166-1-5.833-5a1 1 0 0 0-1.302 0l-5.833 5-1.167 1v.001ZM17.833 9 12 4l7 6-1-.857L17.833 9ZM12 13h4v6h-4v-6Z" />',
};
